import styled from "styled-components";
import BreakPoints from "src/general/constants/breakPoints";
import Colors from "src/general/constants/colors";

export const Footer = styled.footer`
	padding: 60px 100px 0;
	background: ${Colors.GREEN};
	@media (max-width: ${BreakPoints.DESKTOPS}) {
		padding: 40px 16px 0;
	};
	@media (max-width: ${BreakPoints.MOBILE_768}px) {
		padding: 40px 16px 74px;
	};
`;

export const Image = styled.div`
	width: 100%;
	margin-top: 60px;
	background: ${Colors.GREEN};
	display: flex;
	justify-content: center;
	align-items: center;
	padding-top: 10px;

	& svg {
		width: 100%;
		height: 100%;
		max-width: 1440px;
	}
`;

export const Title = styled.p`
	font-weight: 600;
	font-size: 24px;
	line-height: 30px;
	color: ${Colors.GREY_OLD};
	@media (max-width: ${BreakPoints.DESKTOPS}) {
		font-weight: 600;
		font-size: 16px;
		line-height: 20px;
	}
`;

export const SubTitle = styled.p`
	font-weight: 500;
	font-size: 16px;
	line-height: 20px;
	padding-top: 8px;
	color: ${Colors.GREY_OLD};
	padding-bottom: 24px;
	border-bottom: 1px solid ${Colors.GREY_OLD};
	@media (max-width: ${BreakPoints.DESKTOPS}) {
		font-weight: 500;
		font-size: 14px;
		line-height: 18px;
		padding-bottom: 16px;
	}
`;

export const Wrapper = styled.div`
	display: flex;
	margin-top: 24px;
	justify-content: space-between;

	@media (max-width: ${BreakPoints.DESKTOPS}) {
		margin-top: 16px;
		gap: 24px;
		flex-wrap: wrap;
	}

	@media (max-width: ${BreakPoints.TABLETS}) {
		flex-direction: column;
	}
`;

export const ListItemLogoDeveloper = styled.li`
	font-size: 0;
	margin-top: auto;

	img {
		cursor: pointer;
	}
`;

export const ListLinks = styled.ul`
	display: flex;
	flex-wrap: wrap;
	gap: 24px;
	flex-direction: column;
	max-width: 288px;
	padding-right: 12px;
	@media (max-width: ${BreakPoints.DESKTOPS}) {
		gap: 16px;
		padding-right: 0;
	}
`;

export const ListLinksTwo = styled.ul`
	display: flex;
	flex-wrap: wrap;
	gap: 20px;
	flex-direction: column;
	@media (max-width: ${BreakPoints.DESKTOPS}) {
		gap: 16px;
	}
`;

export const ListItemLinks = styled.li`
	width: 100%;
	position: relative;
	cursor: pointer;
`;

export const Address = styled.a`
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	color: ${Colors.GREY_OLD};
	@media (max-width: ${BreakPoints.DESKTOPS}) {
		font-weight: 400;
		line-height: 16px;
	}
`;

export const Phone = styled.a`
	font-weight: 600;
	font-size: 18px;
	line-height: 24px;
	color: ${Colors.GREY_OLD};
`;

export const PhoneDescription = styled.span`
	font-weight: 500;
	font-size: 12px;
	line-height: 16px;
	color: ${Colors.GREY_OLD};
	display: block;
	margin-top: 2px;
`;

export const WebSite = styled.a`
	font-weight: 600;
	font-size: 18px;
	line-height: 24px;
	color: ${Colors.GREY_OLD};
`;

export const ListNetworks = styled.ul`
	display: flex;
	align-items: center;
	gap: 24px;
	@media (max-width: ${BreakPoints.DESKTOPS}) {
		padding-top: 8px;
	}

	&:after {
		content: "*";
		font-weight: 500;
		font-size: 20px;
		margin-left: -16px;
		line-height: 24px;
		color: ${Colors.GREY_OLD};
	}
`;

export const ListItemNetworks = styled.li`
	font-size: 0;
`;

export const Link = styled.a`
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	color: ${Colors.GREY_OLD};

	@media (max-width: ${BreakPoints.DESKTOPS}) {
		font-weight: 400;
		line-height: 16px;
	}
`;

export const FooterText = styled.p`
	font-weight: 500;
	font-size: 12px;
	line-height: 16px;
	color: ${Colors.GREY_OLD};
	padding: 12px 0 24px 0;
	margin-top: 24px;

	@media (max-width: ${BreakPoints.DESKTOPS}) {
		font-weight: 400;
		line-height: 16px;
		border-top: 1px solid ${Colors.WHITE};
	}
`;
